var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 10.7949,
    cy: 10.4275,
    r: 10,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_4625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24305 12.8779 L7.01736 10.5131L6.92666 10.4167L6.83562 10.5128L6.04673 11.345L5.96551 11.4307L6.04643 11.5167L9.15198 14.8164L9.24301 14.9131L9.33403 14.8164L16.0007 7.73303L16.0813 7.64736L16.0007 7.56168L15.2174 6.72939L15.1264 6.63272L15.0354 6.72935L9.24305 12.8779 Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_4625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 14.1667,
    fill: "white",
    transform: "translate(3.25745 3.62491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskStatus);
export default __webpack_public_path__ + "static/media/taskStatus.109b8e0206c5a080314f1c390dfa1893.svg";
export { ForwardRef as ReactComponent };